export default __webpack_public_path__ + "static/media/greenGrid.9c24915b.png";